import { Box, Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useLocation, useNavigate } from 'react-router-dom';

// "Back to Settings" for a lab settings section (Departments, Specimen Types,
// Test Catalog, Test Panels). Rendered only when the section is opened as its own
// page (route .../laboratory/settings/<x>). Inside the unified Settings hub these
// sections render as tabs, so the pathname is .../settings and this stays hidden —
// no redundant "back to the page you're already on".
export default function BackToSettings() {
  const location = useLocation();
  const navigate = useNavigate();
  if (!location.pathname.includes('/laboratory/settings/')) return null;
  const basePath = location.pathname.split('/laboratory')[0];
  return (
    <Box sx={{ mt: 2 }}>
      <Button variant="text" startIcon={<ArrowBackIcon />} onClick={() => navigate(`${basePath}/settings`)}>
        Back to Settings
      </Button>
    </Box>
  );
}
